import { createSlice } from "@reduxjs/toolkit";

// Define el estado inicial fuera del createSlice
const initialState = {
  coaches: [],
  loading: false,
  error: null,
  selectedCoach: null,
  coachDetails: {},
  coachProfileDetails: {},
};

export const coachSlice = createSlice({
  name: "coaches",
  initialState,
  reducers: {
    coachesFetchSuccess: (state, action) => {
      state.coaches = action.payload;
    },
    coachLoading: (state, action) => {
      state.loading = action.payload;
    },
    coachError: (state, action) => {
      state.error = action.payload;
    },
    selectCoach: (state, action) => {
      state.selectedCoach = action.payload;
    },
    setCoachDetails: (state, action) => {
      state.coachDetails = action.payload;
      state.loading = false;
      state.error = null;
    },
    setCoachProfile: (state, action) => {
      state.coachProfileDetails = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  coachesFetchSuccess,
  coachLoading,
  coachError,
  selectCoach,
  setCoachDetails,
  setCoachProfile,
} = coachSlice.actions;
export default coachSlice.reducer;
